module.exports = __webpack_public_path__ + "assets/img/group-logo-962291cf.png";